<main class="status-page min-h-screen">
  <div class="brand-gradient-bar absolute inset-x-0 top-0 h-1.5"></div>

  <div class="relative mx-auto flex min-h-screen w-full max-w-6xl items-center px-5 py-12 lg:px-8">
    <div class="grid w-full overflow-hidden rounded-[2rem] shadow-2xl lg:grid-cols-[1.05fr_0.95fr]">
      <section class="brand-panel-surface hidden min-h-[680px] flex-col justify-between p-12 lg:flex">
        <a routerLink="/" class="flex w-fit items-center gap-3" aria-label="All Nigeria Community home">
          <span class="brand-logo-frame size-16 overflow-hidden rounded-full">
            <img src="/assets/icon/ancLogo.jpeg" alt="All Nigeria Community Ghana" class="size-full object-cover">
          </span>
          <span>
            <strong class="block font-heading text-lg tracking-tight">ANC Ghana</strong>
            <small class="block font-semibold uppercase tracking-[0.22em] text-gold">One Nation, One People</small>
          </span>
        </a>

        <div class="max-w-md">
          <p class="mb-5 text-sm font-bold uppercase tracking-[0.24em] text-gold">Membership portal</p>
          <h1 class="text-4xl font-extrabold leading-tight tracking-tight xl:text-5xl">Your application journey, all in one place.</h1>
          <p class="mt-6 text-lg leading-relaxed text-white/65">Use the phone number and serial code from your registration to securely continue to your membership dashboard.</p>
        </div>

        <p class="text-sm text-white/45">All Nigeria Community Ghana · Kisseman, Accra</p>
      </section>

      <section hlmCard class="login-card flex min-h-[680px] flex-col justify-center rounded-none border-0 px-6 py-10 sm:px-12 lg:px-14">
        <div class="mx-auto w-full max-w-md">
          <button hlmBtn routerLink="/" size="sm" variant="ghost" class="mb-10 -ml-2">
            <ng-icon name="matArrowBackOutline" />
            Back to home
          </button>

          <div class="mb-9 lg:hidden">
            <img src="/assets/icon/ancLogo.jpeg" alt="All Nigeria Community Ghana" class="size-16 rounded-full object-cover shadow-md">
          </div>

          <div hlmCardHeader class="p-0">
            <p class="mb-3 text-sm font-bold uppercase tracking-[0.2em] text-primary">Application access</p>
            <h2 hlmCardTitle class="text-3xl font-extrabold tracking-tight sm:text-4xl">Welcome back</h2>
            <p hlmCardDescription class="mt-3 text-base leading-relaxed">Enter your registration details to check your status and continue your application.</p>
          </div>

          <form class="mt-9 flex flex-col gap-6" [formGroup]="loginForm" (ngSubmit)="onSubmit()">
            <div hlmField>
              <label hlmFieldLabel for="phone">Phone number</label>
              <input hlmInput id="phone" type="tel" inputmode="tel" autocomplete="tel" formControlName="phone" placeholder="e.g. 024 000 0000" class="h-12 w-full" required>
              <p hlmFieldDescription>Use the number entered during registration.</p>
            </div>

            <div hlmField>
              <label hlmFieldLabel for="serial">Serial code</label>
              <input hlmInput id="serial" type="text" autocomplete="off" autocapitalize="characters" formControlName="serial" placeholder="Enter your serial code" class="h-12 w-full" required>
            </div>

            @if (errorMessage()) {
              <div hlmAlert variant="destructive" role="alert">
                <ng-icon name="lucideCircleAlert" />
                <div hlmAlertDescription>{{ errorMessage() }}. Check your details and try again.</div>
              </div>
            }

            <button hlmBtn size="lg" type="submit" [disabled]="loginForm.invalid || isLoading()" class="mt-1 h-12 w-full text-sm font-bold">
              @if (isLoading()) {
                <hlm-spinner />
                Checking details…
              } @else {
                <ng-icon name="lucideSearch" />
                Check application status
              }
            </button>
          </form>

          <div class="mt-8 border-t border-border pt-6 text-center text-sm text-muted-foreground">
            Haven't registered yet?
            <a routerLink="/register" class="font-bold text-primary hover:underline">Start registration</a>
          </div>
        </div>
      </section>
    </div>
  </div>
</main>
